import styled from 'styled-components';

export const Root = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 0 130px;
  position: relative;
  text-align: center;
  font-family: 'General Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  color: var(--color-text);
`;
